/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import Styles from './Home24C2C.css';
import RedButton from '@/components/atoms/RedButton';

function Home24C2C() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <section id="santander-c2c">
      <ContainerHome24>
        <div className="santander-c2c-contain">
          <a href="financiamento-entre-particulares.html?t=comprador" className="card-c2c comprar">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 400 && (
                  <picture>
                    {/* <source type="image/webp" srcSet="assets/home24/c2c-comprar.webp" /> */}
                    <source type="image/png" srcSet="assets/home24/c2c-comprar.png" />
                    <img
                      src="assets/home24/c2c-comprar.png"
                      alt="Mulher sentada em um carro vermelho aperta a mão de um homem parado do lado de fora da janela do motorista ao realizarem a venda do veículo financiado pela Santander Financiamentos"
                      className=""
                    />
                  </picture>
                )}
                {width > 400 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/home24/c2c-comprar-desk.webp" />
                    <source type="image/png" srcSet="assets/home24/c2c-comprar-desk.png" />
                    <img
                      src="assets/home24/c2c-comprar.png"
                      alt="Mulher sentada em um carro vermelho aperta a mão de um homem parado do lado de fora da janela do motorista ao realizarem a venda do veículo financiado pela Santander Financiamentos"
                      className=""
                    />
                  </picture>
                )}
              </>
            )}
            <h3 className="c2c-title">Comprar um veículo</h3>
            <p className="c2c-text">
              Compre seu veículo direto com o dono e financie com o Santander. Temos tudo que você
              procura em uma financeira!
            </p>
            <p className="c2c-link">Saiba mais</p>
          </a>
          <a href="financiamento-entre-particulares.html?t=vendedor" className="card-c2c vender">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 400 && (
                  <picture>
                    {/* <source type="image/webp" srcSet="assets/home24/c2c-vender.webp" /> */}
                    <source type="image/png" srcSet="assets/home24/c2c-vender.png" />
                    <img
                      src="assets/home24/c2c-vender.png"
                      alt="Dois homens apertam as mãos ao lado de um carro vermelho ao realizarem a venda do veículo financiado pela Santander Financiamentos, enquanto uma mulher está sentada dentro do veículo."
                      className=""
                    />
                  </picture>
                )}
                {width > 400 && (
                  <picture>
                    <source type="image/webp" srcSet="assets/home24/c2c-vender-desk.webp" />
                    <source type="image/png" srcSet="assets/home24/c2c-vender-desk.png" />
                    <img
                      src="assets/home24/c2c-vender-desk.png"
                      alt="Dois homens apertam as mãos ao lado de um carro vermelho ao realizarem a venda do veículo financiado pela Santander Financiamentos, enquanto uma mulher está sentada dentro do veículo."
                      className=""
                    />
                  </picture>
                )}
              </>
            )}
            <h3 className="c2c-title">Vender seu veículo</h3>
            <p className="c2c-text">
              Alguém quer comprar seu veículo? Indique o financiamento Santander. Você{' '}
              <b>vende financiado</b>, e <b>a gente</b> paga você à vista!
            </p>
            <p className="c2c-link">Saiba mais</p>
          </a>
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24C2C;
